'use client';

import { isBusinessUatCookieSet, ROUTES } from '@shared/utils';
import { useEffect } from 'react';

const getRelativePath = (url: string | undefined): string => {
  if (!url) return '';
  try {
    if (url.startsWith('/') && !url.startsWith('//')) {
      return url;
    }
    const urlObj = new URL(url);
    return urlObj.pathname;
  } catch {
    return url;
  }
};

const isScratchcardsPath = (pathname: string): boolean => {
  const discovery = ROUTES.SCRATCHCARDS.DISCOVERY;
  return pathname === discovery || pathname.startsWith(`${discovery}/`);
};

const LEGACY_ROUTES = [ROUTES.FOOTER?.NAVIGATION?.LOTTERY?.RESULTS, ROUTES.FOOTER?.NAVIGATION?.LOTTERY?.SYNDICATES, ROUTES.BETCLUB].filter(Boolean) as string[];

const LEGACY_PREFIXES = Array.from(
  new Set(
    LEGACY_ROUTES.flatMap(route => {
      const relative = getRelativePath(route);
      return relative && relative !== route ? [route, relative] : [route];
    })
  )
);

function LegacyRouteInterceptor(): null {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const handler = (ev: MouseEvent) => {
      const target = ev.target as HTMLElement | null;
      const anchor = target?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!anchor) return;

      const hrefAttribute = anchor.getAttribute('href') || '';
      const hrefCandidates = [hrefAttribute, anchor.href].filter(Boolean);

      const scratchcardsHref = !isBusinessUatCookieSet() ? hrefCandidates.find(href => isScratchcardsPath(getRelativePath(href))) : undefined;
      const matchedHref = scratchcardsHref || hrefCandidates.find(candidate => LEGACY_PREFIXES.some(prefix => candidate.startsWith(prefix)));

      if (matchedHref) {
        ev.preventDefault();
        window.dispatchEvent(new CustomEvent('legacy:open', { detail: { href: matchedHref } }));
      }
    };

    document.addEventListener('click', handler, { capture: true });
    return () => document.removeEventListener('click', handler, { capture: true });
  }, []);

  return null;
}

export { LegacyRouteInterceptor };
